import { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';

const TableCheckboxActionsBase = styled.div<{ height?: number; withoutSpacing?: boolean }>`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  grid-column-gap: var(--spacing-6);

  padding-top: var(--spacing-5);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-6);

  position: sticky;
  top: -2.8rem;
  background: var(--white);
  z-index: 100;

  &:empty {
    height: 0;
    padding: 0;

    & + table {
      margin-top: var(--spacing-5);
    }
  }

  &:not(:empty) + table > thead {
    top: ${({ height }) => (height ? `${(height - 28) / 10}rem` : '-2.8rem')};
  }

  ${({ withoutSpacing }) =>
    withoutSpacing &&
    css`
      padding-top: 0;

      &:empty + table {
        margin-top: 0;
      }
    `}
`;

export const TableCheckboxActions = ({ children, withoutSpacing }: any) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!ref.current) return;

    const updateHeight = () => {
      if (!ref.current) return;

      const newHeight = ref.current.getBoundingClientRect().height;
      setHeight((prev) => (prev !== newHeight ? newHeight : prev));
    };

    const observer = new ResizeObserver(updateHeight);
    observer.observe(ref.current);

    updateHeight();

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <TableCheckboxActionsBase
      ref={ref}
      className="table-checkbox-actions"
      height={height}
      withoutSpacing={withoutSpacing}
    >
      {children}
    </TableCheckboxActionsBase>
  );
};
